var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5625C4.5525 17.5625 0.9375 13.9475 0.9375 9.5C0.9375 5.0525 4.5525 1.4375 9 1.4375C13.4475 1.4375 17.0625 5.0525 17.0625 9.5C17.0625 13.9475 13.4475 17.5625 9 17.5625ZM9 2.5625C5.175 2.5625 2.0625 5.675 2.0625 9.5C2.0625 13.325 5.175 16.4375 9 16.4375C12.825 16.4375 15.9375 13.325 15.9375 9.5C15.9375 5.675 12.825 2.5625 9 2.5625Z",
    fill: "#38879F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.783 12.4478C11.6855 12.4478 11.588 12.4253 11.498 12.3653L9.17297 10.9778C8.59547 10.6328 8.16797 9.87531 8.16797 9.20781V6.13281C8.16797 5.82531 8.42297 5.57031 8.73047 5.57031C9.03797 5.57031 9.29297 5.82531 9.29297 6.13281V9.20781C9.29297 9.47781 9.51797 9.87531 9.75047 10.0103L12.0755 11.3978C12.3455 11.5553 12.428 11.9003 12.2705 12.1703C12.158 12.3503 11.9705 12.4478 11.783 12.4478Z",
    fill: "#38879F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.08c16889baba3f6b4b8e877543dd360a.svg";
export { ForwardRef as ReactComponent };